import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, AssignmentDto, AssignmentReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AssignmentInline, { AssignmentInlineProps } from "./AssignmentInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: AssignmentDto | AssignmentReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<AssignmentInlineProps>;
}

export default function AssignmentLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AssignmentRead]}
      to={ROUTE_PATH.ASSIGNMENT_VIEW(entity?.id || entityId || "")}
      content={
        <AssignmentInline
          entity={entity}
          entityId={entityId}
          {...inlineProps}
          withTooltip={false}
        />
      }
      {...otherProps}
    />
  );
}
